 $( document ).ready(function() {
   
   function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
   
   function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
       if(getCookie('homepagePopup') == '' || getCookie('homepagePopup') == undefined ){
          $('#modal').show();
         setCookie('homepagePopup', 'opened', 4) 
     }
     else{
      $('#modal').hide();       
    }
   
   $('.annoucement_slide').slick({
    slidesToShow:1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
     adaptiveHeight: false,
     fade: true,
     speed: 1500,
     arrows:false
  });

 // $('.slideshow').slick({
 //    slidesToShow:1,
 //    slidesToScroll: 1,
 //    autoplay: true,
 //    infinite: true,
 //     arrows:false,
 //    prevArrow : '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
 //  nextArrow : '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
 
 //  });

// =================collection list js slider================= 



$('.cstm_collectionslider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 2000,
   centerMode: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
         arrows: false,
        slidesToScroll: 1
    }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
         arrows: false,
        slidesToScroll: 1,
      }
    }
    
  ],
});

//   $('.cstm_collectionslider .slick-slide[data-slick-index="-1"]').addClass('spacing-first');
  
// $('.cstm_collectionslider').on('afterChange', function (event, slick, currentSlide) {
//   // $('.cstm_collectionslider .slick-slide[data-slick-index="-1"]').removeClass('spacing-first'); 

// });
      

$('.blog-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay:false,
  arrows:true,
  infinite:true,
  centerMode: false,
  autoplaySpeed: 2000,
  prevArrow : '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
  nextArrow : '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
   responsive: [
    {
      breakpoint: 768,
      settings: {
      arrows: false,
       slidesToShow: 2
      }
    },
    {
      breakpoint: 540,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]
});



   $( window ).resize(function() {
      var width = $( window ).width();
     if(width > '640'){
   		 $('.footer_links_title').parents(".site-footer__item-inner").find("ul.site-footer__linklist").show();
     
       
     }else{
        $('.footer_links_title').parents(".site-footer__item-inner").find("ul.site-footer__linklist").hide();
     
     }
   });
   
   
 $("body").on("click",".footer_links_title", function(e){
   e.preventDefault();
   var width = $( window ).width();
  if(width <='640'){
      $('.footer_links_title').not(this).parents(".site-footer__item-inner").find("ul.site-footer__linklist").hide();
      $('.footer_links_title').not(this).removeClass("active");
      $(this).parents(".site-footer__item-inner").find("ul.site-footer__linklist").slideToggle();
      $(this).toggleClass("footer-active");
  }
    });
 });
  